export const publicProfileTranslations = {
  en: {
  basic_details: "Basic Details",
  fighter_details: "Fighter Details",
  fight_history: "Fight History",
  achievements: "Achievements",
  video_url: "Video Content",
  overall_rating: "Overall Rating",
  sponsorships: "Sponsorships",
  ratings_reviews: "Ratings & Reviews",
  ratings: "Ratings",
  ratings_tab_info: "Click the rating tab and check the ratings!",
  no_sponserships: "No Sponsorship",
  youtube_links: "YouTube Links",
  nationality: "Nationality",
  residence_country: "Residence Country",
  phone: "Phone",
  region: "Region",
  fight_scores: "Fight Scores",
  profile_status: "Profile Status",
  verified: "Verified",
  gender:"Gender",
  organization_name: "Organization Name",
  bio: "Biography",
  nickname: "Nickname",
  date_of_birth: "Date of Birth",
  profile_copied_to_clipboard: "Profile copied to clipboard",
  stance: "Stance",
  height: "Height",
  weight: "Weight",
  reach: "Reach",
  team: "Team",
  gym: "Gym",
  title_holder: "Title Holder",
  training_disciplines: "Training Disciplines",
  weight_classes: "Weight Classes",
  fight_style_description: "Fight Style Description",
  opponent: "Opponent",
  date: "Date",
  result: "Result",
  round: "Round",
  location: "Location",
  organization: "Organization",
  type_of_ending: "Type of Ending",
  rule_set: "Rule Set",
  no_fight_history: "No fight history available.",
  no_achievements: "No achievements available.",
  no_video_url: "No video available.",
  no_youtube_links: "No YouTube links available.",
  title: "Title",
  description: "Description",
  invalid_youtube_url: "Invalid YouTube URL",
  email: "Email",
  status: "Status",
  edit_profile: "Edit Profile",
  verified_button: "Verified",
  unverified_button: "Unverified",
  reported: "Reported",
  report_abuse: "Report Abuse",
  loading: "Loading...",
  profile_not_found: "Profile not found",
  cancel: "Cancel",
  copy_profile_link: "Profile link copied",

  // Fighter scores
  amateur: "Amateur",
  professional: "Professional",
  wins: "Wins",
  losses: "Losses",
  ko: "KO",
  tko: "TKO",
  submission: "Submission",
  decision: "Decision",
  draw: "Draw",
  dq: "DQ",
  no_contest: "No Contest",
  total_fights: "Total Fights",
  no_amateur_scores: "No amateur scores",
  no_professional_scores: "No professional scores",
  failed_to_copy_profile: "Failed to copy profile",
  posts: "Posts",
  post: "post",
  posts_count: "posts",
  no_posts_yet: "No posts yet",
  like: "like",
  likes: "likes",
  comment: "comment",
  comments: "comments",
  no_comments_yet: "No comments yet",
  show_comments: "Show comments",
  page: "Page",
  of: "of",
  previous_posts_page: "Previous posts page",
  next_posts_page: "Next posts page",
  profile: "Profile",
  view_profile_aria: "View {{name}} profile",
  failed_to_fetch_posts: "Failed to fetch posts",
  failed_to_fetch_comments: "Failed to fetch comments"
},

  de: { 
 basic_details: "Basisinformationen",
  fighter_details: "Kämpferinformationen",
  fight_history: "Kampfverlauf",
  achievements: "Erfolge",
  video_url: "Video-Inhalt",
  sponsorships: "Sponsoring",
  overall_rating: "Gesamtbewertung",
  ratings_reviews: "Bewertungen & Rezensionen",
  ratings_tab_info: "Klicken Sie auf den Bewertungs-Tab und überprüfen Sie die Bewertungen!",
  no_sponserships: "Kein Sponsoring",
  youtube_links: "YouTube-Links",
  nationality: "Nationalität",
  residence_country: "Wohnsitzland",
  ratings: "Bewertungen",
  phone: "Telefon",
  region: "Region",
  fight_scores: "Kampfergebnisse",
  profile_status: "Profilstatus",
  verified: "Verifiziert",
  organization_name: "Name der Organisation",
  bio: "Biografie",
  nickname: "Spitzname",
  date_of_birth: "Geburtsdatum",
  profile_copied_to_clipboard: "Profil in die Zwischenablage kopiert",
  stance: "Stellung",
  height: "Größe",
  weight: "Gewicht",
  reach: "Reichweite",
  team: "Team",
  gym: "Fitnessstudio",
  title_holder: "Titelträger",
  training_disciplines: "Trainingsdisziplinen",
  weight_classes: "Gewichtsklassen",
  fight_style_description: "Kampfstilbeschreibung",
  opponent: "Gegner",
  date: "Datum",
  result: "Ergebnis",
  round: "Runde",
  location: "Ort",
  organization: "Organisation",
  type_of_ending: "Art des Endes",
    gender: "Geschlecht",
  rule_set: "Regelsatz",
  no_fight_history: "Keine Kampfhistorie verfügbar.",
  no_achievements: "Keine Erfolge verfügbar.",
  no_video_url: "Kein Video verfügbar.",
  no_youtube_links: "Keine YouTube-Links verfügbar.",
  title: "Titel",
  description: "Beschreibung",
  invalid_youtube_url: "Ungültige YouTube-URL",
  email: "E-Mail",
  status: "Status",
  edit_profile: "Profil bearbeiten",
  verified_button: "Verifiziert",
  unverified_button: "Nicht verifiziert",
  reported: "Gemeldet",
  report_abuse: "Missbrauch melden",
  loading: "Laden...",
  profile_not_found: "Profil nicht gefunden",
  cancel: "Abbrechen",
  copy_profile_link: "Profil-Link kopiert",

  // Fighter scores
  amateur: "Amateur",
  professional: "Professionell",
  wins: "Siege",
  losses: "Niederlagen",
  ko: "KO",
  tko: "TKO",
  submission: "Aufgabe",
  decision: "Entscheidung",
  draw: "Unentschieden",
  dq: "Disqualifikation",
  no_contest: "Kein Wettbewerb",
  total_fights: "Gesamtkämpfe",
  no_amateur_scores: "Keine Amateurergebnisse",
  no_professional_scores: "Keine Professionellergebnisse",
  failed_to_copy_profile: "Profil konnte nicht kopiert werden",
  posts: "Beiträge",
  post: "Beitrag",
  posts_count: "Beiträge",
  no_posts_yet: "Noch keine Beiträge",
  like: "Like",
  likes: "Likes",
  comment: "Kommentar",
  comments: "Kommentare",
  no_comments_yet: "Noch keine Kommentare",
  show_comments: "Kommentare anzeigen",
  page: "Seite",
  of: "von",
  previous_posts_page: "Vorherige Beitragsseite",
  next_posts_page: "Nächste Beitragsseite",
  profile: "Profil",
  view_profile_aria: "Profil von {{name}} anzeigen",
  failed_to_fetch_posts: "Beiträge konnten nicht geladen werden",
  failed_to_fetch_comments: "Kommentare konnten nicht geladen werden"
  },
  hr: {
    basic_details: "Osnovni podaci",
  fighter_details: "Podaci o borcu",
  fight_history: "Povijest borbi",
  achievements: "Postignuća",
  video_url: "Video sadržaj",
  sponsorships: "Sponzorstvo",
    ratings: "Ocjene",
    ratings_reviews: "Ocjene i Recenzije",
  ratings_tab_info: "Kliknite na karticu ocjena i provjerite ocjene!",
  no_sponserships: "Nema sponzorstva",
  youtube_links: "YouTube poveznice",
  nationality: "Nacionalnost",
  residence_country: "Država prebivališta",
  phone: "Telefon",
  region: "Regija",
  fight_scores: "Rezultati borbe",
  profile_status: "Status profila",
  verified: "Verificiran",
  organization_name: "Naziv organizacije",
  bio: "Biografija",
  nickname: "Nadimak",
  date_of_birth: "Datum rođenja",
  profile_copied_to_clipboard: "Profil je kopiran u međuspremnik",
  stance: "Stav",
  height: "Visina",
  weight: "Težina",
  reach: "Dohvat",
  team: "Tim",
  gym: "Teretana",
  title_holder: "Nositelj titule",
  training_disciplines: "Discipline treninga",
  weight_classes: "Težinske kategorije",
  fight_style_description: "Opis stila borbe",
  opponent: "Protivnik",
  date: "Datum",
  result: "Rezultat",
  round: "Runda",
  location: "Lokacija",
  organization: "Organizacija",
  type_of_ending: "Vrsta završetka",
  rule_set: "Pravila",
  no_fight_history: "Nema dostupne povijesti borbi.",
  no_achievements: "Nema dostupnih postignuća.",
  no_video_url: "Nema dostupnog video linka.",
  no_youtube_links: "Nema dostupnih YouTube poveznica.",
  title: "Naslov",
  description: "Opis",
  invalid_youtube_url: "Nevažeći YouTube URL",
  email: "E-mail",
  status: "Status",
  edit_profile: "Uredi profil",
  verified_button: "Verificiran",
  unverified_button: "Neverificiran",
  gender: "Spol",
  reported: "Prijavljen",
  report_abuse: "Prijavi zloupotrebu",
  loading: "Učitavanje...",
  profile_not_found: "Profil nije pronađen",
  cancel: "Otkaži",
  overall_rating: "Ukupna ocjena",
  copy_profile_link: "Poveznica profila kopirana",

  // Fighter scores translations
  amateur: "Amaterski",
  professional: "Profesionalni",
  wins: "Pobjede",
  losses: "Porazi",
  ko: "KO",
  tko: "TKO",
  submission: "Predaja",
  decision: "Odluka",
  draw: "Neriješeno",
  dq: "Diskvalifikacija",
  no_contest: "Bez natjecanja",
  total_fights: "Ukupno borbi",
  no_amateur_scores: "Nema amaterskih rezultata",
  no_professional_scores: "Nema profesionalnih rezultata",
  failed_to_copy_profile: "Kopiranje profila nije uspjelo",
  posts: "Objave",
  post: "objava",
  posts_count: "objave",
  no_posts_yet: "Još nema objava",
  like: "sviđanje",
  likes: "sviđanja",
  comment: "komentar",
  comments: "komentari",
  no_comments_yet: "Jos nema komentara",
  show_comments: "Prikaži komentare",
  page: "Stranica",
  of: "od",
  previous_posts_page: "Prethodna stranica objava",
  next_posts_page: "Sljedeća stranica objava",
  profile: "Profil",
  view_profile_aria: "Prikaži profil {{name}}",
  failed_to_fetch_posts: "Učitavanje objava nije uspjelo",
  failed_to_fetch_comments: "Učitavanje komentara nije uspjelo",
  
  }
};
